module.exports = __webpack_public_path__ + "img/trash.6cf5345c.svg";